import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { PeriodoAcesso } from "../../model/solicitacao";
import { ToastrService } from "ngx-toastr";
import { DataUtil } from '../../util/data';
import { OwlDateTimeIntl } from 'ng-pick-datetime';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-adicionar-periodo',
  templateUrl: './modal-adicionar-periodo.component.html',
  styleUrls: ['./modal-adicionar-periodo.component.scss'],
})
export class ModalAdicionarPeriodoComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() periodoAcesso: PeriodoAcesso = new PeriodoAcesso();

  // dtFim: string;
  // dtInicio: string;
  // periodoMaiorAcesso: string;

  @Output() fecharModal = new EventEmitter();

  get startHours() {
    if (this.isManha) {
      return new Date(new Date().setHours(0,0,0));
    }
    if (this.isTarde) {
      return new Date(new Date().setHours(12,0,0));
    }
    if (this.isNoite) {
      return new Date(new Date().setHours(18,0,0));
    }
    return new Date(new Date().setHours(0,0,0));
  }
  get endHours() {
    if (this.isManha) {
      return new Date(new Date().setHours(11,59,0));
    }
    if (this.isTarde) {
      return new Date(new Date().setHours(17,59,0));
    }
    if (this.isNoite) {
      return new Date(new Date().setHours(23,59,0));
    }
    return new Date(new Date().setHours(0,0,0));
  }

  get isManha() { return this.periodoAcesso.periodoMaiorAcesso === 'MANHA' }
  get isTarde() { return this.periodoAcesso.periodoMaiorAcesso === 'TARDE' }
  get isNoite() { return this.periodoAcesso.periodoMaiorAcesso === 'NOITE' }

  constructor(
    private toast: ToastrService,
  ) {}

  ngOnInit() {
  }

  fechar(data?) {
    this.fecharModal.emit();
  }

  salvar() {
    if (!this.periodoAcesso.periodoMaiorAcesso) {
      this.toast.error('Preencha o campo Período');
      return;
    }

    if (!this.periodoAcesso.dtInicio) {
      this.toast.error('Preencha o campo Início');
      return;
    }

    if (!this.periodoAcesso.dtFim) {
      this.toast.error('Preencha o campo Fim');
      return;
    }
    let dtIni = moment(this.periodoAcesso.dtInicio).format('HH:mm')
    let dtFim = moment(this.periodoAcesso.dtFim).format('HH:mm')
    console.log()
    const matchIni = /((?:[01]\d|2[0123])):((?:[012345]\d))/gm.exec(dtIni);
    const matchFim = /((?:[01]\d|2[0123])):((?:[012345]\d))/gm.exec(dtFim);

    if (!matchIni || !matchFim) {
      this.toast.error('Horário inválido');
      return;
    }

    const iniTime = new Date().setHours(parseInt(matchIni[ 1 ], 10), parseInt(matchIni[ 2 ], 10), 0);
    const fimTime = new Date().setHours(parseInt(matchFim[ 1 ], 10), parseInt(matchFim[ 2 ], 10), 0);

    // validação de turno com horário
    if (this.periodoAcesso.periodoMaiorAcesso === 'MANHA') {
      const minTime = new Date().setHours(0, 0, 0);
      const maxTime = new Date().setHours(12, 0, 0);

      if (iniTime < minTime || iniTime > maxTime || fimTime < minTime || fimTime > maxTime) {
        this.toast.error('Horário incompatível com período selecionado');
        return;
      }
    } else if (this.periodoAcesso.periodoMaiorAcesso === 'TARDE') {
      const minTime = new Date().setHours(12, 0, 0);
      const maxTime = new Date().setHours(18, 0, 0);

      if (iniTime < minTime || iniTime > maxTime || fimTime < minTime || fimTime > maxTime) {
        this.toast.error('Horário incompatível com período selecionado');
        return;
      }
    } else if (this.periodoAcesso.periodoMaiorAcesso === 'NOITE') {
      const minTime = new Date().setHours(18, 0, 0);
      const maxTime = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0);

      if (iniTime < minTime || iniTime > maxTime || fimTime < minTime || fimTime > maxTime) {
        this.toast.error('Horário incompatível com período selecionado');
        return;
      }
    }
    
    if (
      DataUtil.isHorarioMaior(dtIni, dtFim)
    ) {
        this.toast.error('Horário inválido');
        return;
    }


    this.periodoAcesso.dtInicio= dtIni;
    this.periodoAcesso.dtFim = dtFim;
    this.fecharModal.emit(this.periodoAcesso);
  }

}

export class DefaultIntl extends OwlDateTimeIntl {
  public cancelBtnLabel = 'Cancelar';
  public setBtnLabel = 'Selecionar';

  constructor() {
      super();
  }
};



// WEBPACK FOOTER //
// ./src/app/components/modal-adicionar-periodo/modal-adicionar-periodo.component.ts